<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
      </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml">
        <div v-for="page in totalPages" :key="page" class="mx-5 my-4">
          <div v-for="shipmentpage in totalShipmentPages(page-1)"
          :key="shipmentpage" class="mx-5 my-4">
          <div class="pdf-item d-flex text-xs justify-content-between">
            <div>
                  <img
                    src="../assets/gunter_Logo-bg.png"
                    alt="Logo"
                    style="flex: none;"
                    height="30"
                    width="30"
                  />
            </div>
            <div class="text-center">
                  <h4
                  class="text-xs"
                  >
                    GUNTER SHIPPING
                    <br/>
                    {{ response.exporterAddress.toUpperCase() }}
                    <br/>
                    {{ response.exporterCity.toUpperCase() }},
                    {{ response.exporterState.toUpperCase() }}
                    {{ response.exporterZipCode }}
                  </h4>
              </div>
              <div class="text-xs">
                  EXPRESS BILL
              </div>
          </div>
          <div class="pdf-item">
            <table class="table text-xs w-100" style="line-height: 1;">
              <tr>
                <td class="bordered" style="border-left-style: hidden;" rowspan = "2">
                  <div class="smalltext font-weight-bold">
                    EXPORTER
                  </div>
                  <div>
                    {{paginatedData(page-1).shipperInfo.firstName.toUpperCase()}}
                    {{paginatedData(page-1).shipperInfo.lastName.toUpperCase()}}
                    <br/>
                    {{paginatedData(page-1).shipperInfo.address.toUpperCase()}}
                    <br/>
                    {{paginatedData(page-1).shipperInfo.city.toUpperCase()}},
                    {{paginatedData(page-1).shipperInfo.state.toUpperCase()}}
                    {{paginatedData(page-1).shipperInfo.zipCode}}
                    <br/>
                    Tel: {{paginatedData(page-1).shipperInfo.phone}}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    BL NUMBER
                  </div>
                  <div>
                    {{ response.billOfLading }}
                  </div>
                </td>
                <td  class="bordered" style="border-right-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    BOOKING NO.
                  </div>
                  <div>
                    {{ response.billOfLading }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    EXPORTER REFERENCES
                  </div>
                  <div>
                    {{ response.exporterReference }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;" rowspan = "2">
                  <div class="smalltext font-weight-bold ">
                    CONSIGNED TO
                  </div>
                  <div>
                    {{paginatedData(page-1).consigneeInfo.firstName.toUpperCase()}}
                    {{paginatedData(page-1).consigneeInfo.lastName.toUpperCase()}}
                    <br/>
                    {{paginatedData(page-1).consigneeInfo.address.toUpperCase()}}
                    <br/>
                    {{paginatedData(page-1).consigneeInfo.city.toUpperCase()}},
                    {{paginatedData(page-1).consigneeInfo.state.toUpperCase()}}
                    {{paginatedData(page-1).consigneeInfo.zipCode}}
                    <br/>
                    Tel: {{paginatedData(page-1).consigneeInfo.phone}}
                  </div>
                </td>
                <td  class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    FORWARDING AGENT
                  </div>
                  <div>
                    {{ response.forwardingAgentFirstName.toUpperCase() }}
                    {{ response.forwardingAgentLastName.toUpperCase() }}
                    <br/>
                    {{ response.forwardingAgentAddress.toUpperCase() }}
                    <br/>
                    {{ response.forwardingAgentCity.toUpperCase() }},
                    {{ response.forwardingAgentState.toUpperCase() }}
                    {{ response.forwardingAgentZipCode }}
                    <br/>
                    Tel: {{ response.forwardingAgentPhone }}
                    <br/>
                    FMC: {{ response.forwardingAgentFmc.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    POINT(STATE) OF ORIGIN OR FTZ NUMBER
                  </div>
                  <div>
                    {{ response.ftz.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    NOTIFY PARTY/INTERMEDIATE CONSIGNEE
                  </div>
                  <div>
                    <!-- {{ response.notifyPartyFirstName.toUpperCase() }}
                    {{ response.notifyPartyLastName.toUpperCase() }} -->
                    <br/>
                    <!-- {{ response.notifyPartyAddress.toUpperCase() }} -->
                    <br/>
                    <!-- {{ response.notifyPartyCity.toUpperCase() }},
                    {{ response.notifyPartyState.toUpperCase() }}
                    {{ response.notifyPartyZipCode }} -->
                    <br/>
                    <!-- Tel: {{ response.notifyPartyPhone }} -->
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div>
                    {{ response.freightPaymentType.toUpperCase() }} - FILE {{ response.fileno }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    PRE-CARRIAGE BY
                  </div>
                  <div>
                    {{ response.preCarriage.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    VESSEL/VOYAGE
                  </div>
                  <div>
                    {{ response.vessel.toUpperCase() }} {{ response.voyage.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    EXPORTING CARRIER
                  </div>
                  <div>
                    {{ response.exportingCarriage.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    PORT OF LOADING/EXPORT
                  </div>
                  <div>
                    {{ response.loadingPort.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;"  colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    LOADING PIER/TERMINAL
                  </div>
                  <div>
                    {{ response.loadingPier.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    FOREIGN PORT OF UNLOADING
                  </div>
                  <div>
                    {{ response.unloadingPort.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    PLACE OF DELIVERY BY ON-CARRIER
                  </div>
                  <div>
                    {{ response.destination.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    TYPE OF MOVE
                  </div>
                  <div>
                    {{ deliveryType(response.deliveryType).toUpperCase() }}
                  </div>
                </td>
              </tr>
            </table>

            <table class="table text-xs w-100" style="line-height: 1;">
              <tr>
                <th class="bordered" style="border-left-style: hidden;" colspan="2">
                  CARRIER'S RECEIPT</th>
                <th class="bordered" style="border-right-style: hidden;" colspan="5">
                  PARTICULARS FURNISHED BY SHIPPER * CARRIER NOT RESPONSIBLE</th>
              </tr>
              <tr>
                <th class="bordered" style="border-left-style: hidden;">
                  MARKS AND NUMBERS</th>
                <th class="bordered">PACKAGES</th>
                <th colspan="3" width="50%" class="bordered">DESCRIPTION OF COMMODITIES</th>
                <th class="bordered">GROSS WEIGHT</th>
                <th class="bordered" style="border-right-style: hidden;">MEASUREMENT</th>
              </tr>
              <tr v-for="(item) in paginatedItems(page-1, shipmentpage-1)"
                :key="item.id">
                  <td class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;
                  border-left-style: hidden;" height="10">
                    <!-- {{ item.name }}
                    <br>
                      {{ item.containerType }}
                    <br>
                    SEAL: {{ item.containerSeal }} -->
                  </td>
                  <td class="bordered" style="border-bottom-style: hidden;
                   border-top-style: hidden;"
                   height="10px" width="30%">{{ item.qty}} {{ item.packageType }}</td>
                  <td  colspan="3" width="50%"
                   class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;"
                   height="10px">
                    {{ item.description }}
                  </td>
                  <td class="bordered"
                    style="border-bottom-style: hidden; border-top-style: hidden;"
                    height="10px" width="30%">
                    {{ itemWeight(item.weight,'lb') }} LBS
                    <!-- <br> -->
                    <!-- {{ itemWeight(item.weight,'kg') }} KGS -->
                  </td>
                  <td class="bordered" style="
                   border-bottom-style: hidden; border-right-style: hidden;
                   border-top-style: hidden;"
                   height="10px" width="30%">
                    {{ itemMeasurement(item.volume,'ft') }} CF
                    <!-- <br> -->
                    <!-- {{ itemMeasurement(item.volume, 'm') }} M3 -->
                  </td>
              </tr>
              <!-- <tr> -->
          <!-- <td class="bordered" style="border-left-style: hidden; border-bottom-style: hidden;
          border-top-style: hidden;"></td>
          <td class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;">
          </td>
          <td colspan="3" width="50%"
          class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;">
            {{ response.freightRelease.toUpperCase() }} RELEASE AT DESTINATION
          </td> -->
              <!-- </tr> -->
              <tr>
                <td class="bordered" style=" border-left-style: hidden;
                  border-top-style: hidden;" height="10"></td>
                <td class="bordered" style=" border-top-style: hidden;" height="10">
                </td>
                <th colspan="3" width="50%"
                class="text-right bordered" style="border-top-style: hidden;" height="10">
                  TOTALS
                </th>
                <th class="bordered" rowspan="2">
                  {{ totalShipmentWeight(page-1, 'lb') }} LBS
                  <!-- <br>
                  {{ totalWeight('kg') }} KGS -->
                </th>
                <th class="bordered" style="border-right-style: hidden;" rowspan="2">
                  {{ totalShipmentMeasurement(page-1,'ft') }} CF
                  <!-- <br>
                  {{ totalMeasurement('m') }} M3 -->
                </th>
              </tr>
              <tr>
        <!-- <td class="bordered" style=" border-left-style: hidden; border-top-style: hidden;">
        </td>
        <td class="bordered" style="border-top-style: hidden;"></td>
        <td colspan="3" width="50%" class="bordered" style="border-top-style: hidden;">
          AES ITN# {{ response.aesITN.toUpperCase() }}
        </td> -->
              </tr>
            </table>
          </div>
          <div class="pdf-item">
            <div>
              <table class="table table-bordered smalltext" style="float:left; width:40%;
              line-height: 1;">
                <tr>
                  <th>FREIGHT CHARGES</th>
                  <th>PREPAID</th>
                  <th>COLLECT</th>
                </tr>
                <tr height="80px">
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th>TOTAL NO. OF CONTAINERS OR PACKAGES</th>
                  <th>Number OF ORIGINAL BILL OF LADING</th>
                  <th>FREIGHT PAYABLE AT</th>
                </tr>
                <tr>
                  <td>{{ paginatedData(page-1).length }}</td>
                  <td>{{ response.numberBOL }}</td>
                  <td>{{ response.freightPayable.toUpperCase() }}</td>
                </tr>
                <tr>
                  <th colspan="2">{{ response.freightRelease.toUpperCase() }}</th>
                  <th>{{ response.shippedDate }}</th>
                </tr>
              </table>
            </div>
            <div class="smalltext"  style="float:right;width:58%;">
                LAW AND JURISDICTION CLAUSE: <br>
              The Contract evidenced by or contained in this Bill of Lading shall be governed by
              the law of the United States Of America and any claim or dispute arising hereunder
              or in connection herewith shall (without prejudice to the Carriers right to
              commerce proceedings in any other jurisdiction) be determined by the U.S.
              District Court for the State of Florida.<br>

              RECEIVED by the Carrier the Goods as specified above in apparent good order and
              condition unless otherwise stated, to be transported to such place as agreed
              authorized or permitted herein and subject to all the terms and conditions
              appearing on the front and reverse of this Bill of Lading to which the Merchant
              agrees by accepting this Bill of Lading any local privileges and customs
              notwithstanding. <br>

              The particulars given above as stated by shipper and the weight measure quantity,
              condition, contents and value of the Goods are unknown to the Carrier IN WITNESS
              whereof the number of original Bill of Lading stated below have been signed,
              one of which been accomplished the other(s) to be void. <br>

              BY
              <span class="mr-4">____________________________________</span><br>
              {{ currentUser.firstName.toUpperCase() }}
              {{ currentUser.lastName.toUpperCase() }}
            </div>
          </div>
          <div  v-if="shipmentpage < totalShipmentPages(page-1)" class="html2pdf__page-break" />
          </div>
          <div v-if="page < totalPages" class="html2pdf__page-break" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'CustomerBOL',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      size: 8,
      deliveryTypes: [
        { value: 'porttoport', text: 'port to port' },
        { value: 'preclearance', text: 'pre-clearance' },
        { value: 'doortodoor', text: 'door to door' },
      ],
    };
  },
  computed: {
    totalShipment() {
      let shipment = [];
      this.response.items.container.forEach((container) => {
        container.item.forEach((shipments) => {
          shipment = shipment.concat(shipments);
        });
      });
      return shipment;
    },
    totalPages() {
      const pages = this.totalShipment.length;
      if (pages === 0) {
        return 1;
      }
      return pages;
    },
  },
  methods: {
    totalShipmentPages(page) {
      const items = this.totalShipment[page]?.items || [];
      const pages = Math.ceil(items.length / this.size);
      if (pages === 0) {
        return 1;
      }
      return pages;
    },
    paginatedData(page) {
      const paginated = this.totalShipment[page];
      if (paginated) {
        return paginated;
      }
      return {
        shipper: '',
        shipperInfo: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          country: '',
          zipCode: '',
          email: '',
          phone: '',
          aesITN: '',
          airportCode: '',
        },
        consignee: '',
        consigneeInfo: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          country: '',
          zipCode: '',
          email: '',
          phone: '',
          aesITN: '',
          airportCode: '',
        },
      };
    },
    paginatedItems(page, split) {
      const paginated = this.totalShipment[page]?.items || [];
      const start = split * this.size;
      const end = start + this.size;
      const shipments = paginated.slice(start, end);
      while (shipments < this.size) {
        shipments.push({
          qty: '',
          packageType: '',
          description: '',
          weight: '0',
          volume: '0',
        });
      }
      return shipments;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    itemWeight(weight, type) {
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    itemMeasurement(volume, type) {
      if (type === 'ft') {
        return parseFloat(volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    totalShipmentWeight(page, type) {
      const shipment = this.totalShipment[page]?.items || [];
      let weight = 0;
      shipment.forEach((item) => {
        weight += item.weight;
      });
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    totalShipmentMeasurement(page, type) {
      const shipment = this.totalShipment[page]?.items || [];
      let volume = 0;
      shipment.forEach((item) => {
        volume += item.volume;
      });
      if (type === 'lb') {
        return parseFloat(volume).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    deliveryType(value) {
      const type = this.deliveryTypes.find((delivery) => delivery.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 600,
          scale: 2,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
    // margin-bottom: 5px;
    margin-bottom: 1px;
}
.table {
  margin-bottom: -0.8px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
  padding-top: 0;
}

.heading {
  border-bottom: 1px solid #343434;
}

.bordered {
  border: 1px solid #343434;
  padding-top: 0;
}

.borderedLeft {
  border-left: 1px solid #343434
}

.smalltext {
  font-size: 0.55rem;
  line-height: .8rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}
</style>
